/**
 * ReadinessScoreBar - Visueller Score-Indikator
 */

import { cn } from '@/lib/utils'

interface ReadinessScoreBarProps {
  score: number
  size?: 'sm' | 'md'
  showLabel?: boolean
}

export function ReadinessScoreBar({ score, size = 'md', showLabel = true }: ReadinessScoreBarProps) {
  const color = score >= 90
    ? 'bg-emerald-500'
    : score >= 50
      ? 'bg-amber-500'
      : 'bg-red-500'

  const textColor = score >= 90
    ? 'text-emerald-600 dark:text-emerald-400'
    : score >= 50
      ? 'text-amber-600 dark:text-amber-400'
      : 'text-red-600 dark:text-red-400'

  const height = size === 'sm' ? 'h-1.5' : 'h-2.5'

  return (
    <div className="flex items-center gap-2">
      <div className={cn('flex-1 rounded-full bg-neutral-200 dark:bg-neutral-700', height)}>
        <div
          className={cn('rounded-full transition-all duration-300', color, height)}
          style={{ width: `${Math.min(score, 100)}%` }}
        />
      </div>
      {showLabel && (
        <span className={cn('text-sm font-semibold tabular-nums w-12 text-right', textColor)}>
          {Math.round(score)}%
        </span>
      )}
    </div>
  )
}
